import * as React from "react";

const ArrowDownIcon: React.FC = () => {
    return (
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.329568 11.5805C0.769373 11.1407 1.48129 11.1414 1.92039 11.5805L4.49998 14.1609V1.125C4.49998 0.503086 5.00306 0 5.62498 0C6.24689 0 6.74998 0.503086 6.74998 1.125V14.1609L9.32974 11.5812C9.7692 11.1417 10.4811 11.1417 10.9206 11.5812C11.36 12.0206 11.36 12.7325 10.9206 13.172L6.42056 17.672C5.98111 18.1114 5.2692 18.1114 4.82974 17.672L0.329744 13.172C-0.109885 12.7301 -0.109885 12.0199 0.329568 11.5805Z" fill="#0F96D9" />
        </svg>
    );
};

export default React.memo(ArrowDownIcon);
